<template>
    <!--内容趋势[[-->
    <div class="radar-main g-laboratory-padding" style="display: block;">
        <!--主要内容区域单个区域[[-->
        <div class="laboratory-tabs-main-item">
            <h4 class="tabs-main-item-title">
                <span class="title-bg"></span>
                一周内容建议
                <span>点击词汇可查看相关热词分析</span>
            </h4>
            <div class="tabs-main-item-content" v-loading="loadingConf.tagAdvise">
                <ul class="tabs-main-item-boxs-wrap">
                    <li class="tabs-main-item-box">
                        <h5 class="item-box-title">
                            <i class="ico ico-hero">&nbsp;</i>
                            英雄
                        </h5>
                        <div class="item-box-content">
                            <a :class="`a-model${key+1}`"
                                href="javascript:;"
                                v-for="(tag,key) in trendAdviseTagStat.hero.tags"
                                :key="key"
                                @click="goToTagAnalyze(tag)"
                            >
                                <span>{{ tag.token }}</span>
                            </a>
                        </div>
                    </li>
                    <li class="tabs-main-item-box">
                        <h5 class="item-box-title">
                            <i class="ico ico-strategy"> &nbsp;</i>
                            攻略
                        </h5>
                        <div class="item-box-content">
                            <a  :class="`a-model${key+1}`"
                                href="javascript:;"
                                v-for="(tag,key) in trendAdviseTagStat.gonglue.tags"
                                :key="key"
                                @click="goToTagAnalyze(tag)"
                            >
                                <span>{{ tag.token }}</span>
                            </a>
                        </div>
                    </li>
                    <li class="tabs-main-item-box">
                        <h5 class="item-box-title">
                            <i class="ico ico-team">&nbsp;</i>
                            战队
                        </h5>
                        <div class="item-box-content">
                            <a  :class="`a-model${key+1}`"
                                href="javascript:;"
                                v-for="(tag,key) in trendAdviseTagStat.team.tags"
                                :key="key"
                                @click="goToTagAnalyze(tag)"
                            >
                                <span>{{ tag.token }}</span>
                            </a>
                        </div>
                    </li>
                    <li class="tabs-main-item-box">
                        <h5 class="item-box-title">
                            <i class="ico ico-bigv"> &nbsp;</i>
                            大V
                        </h5>
                        <div class="item-box-content">
                            <a  :class="`a-model${key+1}`"
                                href="javascript:;"
                                v-for="(tag,key) in trendAdviseTagStat.bigV.tags"
                                :key="key"
                                @click="goToTagAnalyze(tag)"
                            >
                                <span>{{ tag.token }}</span>
                            </a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <!--主要内容区域单个区域]]-->

        <!--主要内容区域单个区域[[-->
        <div class="laboratory-tabs-main-item">
            <h4 class="tabs-main-item-title">
                <span class="title-bg"></span>
                内容趋势
            </h4>
            <div class="date-wrap" style="padding-left: 0">
                <!--时间选择器[[-->
                <div>
                    <el-date-picker
                            v-model="contentTrendConf.param.endTime"
                            type="date"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            @change="onDateChange('contentTrendChart')"
                    >
                    </el-date-picker>
                </div>
                <!--时间选择器]]-->
            </div>
            <div class="tabs-main-item-content chart-wrap-container" id="contentTrendChart" v-loading="loadingConf.contentChart">
            </div>

        </div>
        <!--主要内容区域单个区域]]-->

        <!--主要内容区域单个区域[[-->
        <div class="laboratory-tabs-main-item">
            <h4 class="tabs-main-item-title">
                <span class="title-bg"></span>
                热词趋势
            </h4>
            <div class="date-wrap" style="padding-left: 0">
                <div>
                    <el-date-picker
                            v-model="keywordChartConf.param.endTime"
                            type="date"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            @change="onDateChange('hotTagChart')"
                    >
                    </el-date-picker>
                </div>
            </div>
            <div class="tabs-main-item-content  chart-wrap-container" id="keywordChart" v-loading="loadingConf.keywordChart"></div>
        </div>
        <!--主要内容区域单个区域]]-->
    </div>
    <!--内容趋势]]-->
</template>
<style lang="scss" scoped>
    @import  '~Assets/sass/pages/v4/laboratory/radar.scss';
    .radar .laboratory-tabs-main-item .chart-wrap-container {
        height: 402px;
        padding: 0;
        background-size: 100% 100%;
        margin-top: 70px;
    }
    .tabs-main-item-boxs-wrap .tabs-main-item-box:nth-child(1){
        margin-bottom: 40px;
    }
</style>

<script>
import G2 from '@antv/g2';
import DataSet from '@antv/data-set';

import {
    TrendAdviseTagList, ContentTrendsData, KeywordTrendsData
} from 'Services/getData.js';
export default {
    data() {
        return {
            contentTrendsStat: [],
            contentTrendConf: {
                	dKey: [],
                colorMap: [],
                param: {
                		endTime: new Date(new Date().getTime() -24*60*60*1000).toLocaleDateString()
		            }
            },
            contentTrendChart: null,
            colors: [
                '#a7d5fb',
                '#64b5f6',
                '#2196f3',
                '#1976d2',
                '#1a7fd3',
                '#ffccbc',
                '#ffa183',
                '#ff7b52',
                '#e65224',
                '#e12224'
            ],
            keywordStat: [],
            keywordChartConf: {
                	fields: [],
	                param: {
		                endTime: new Date(new Date().getTime() -24*60*60*1000).toLocaleDateString()
	                }
            },
            keywordChart: null,
            keywordChartDV: null,
            trendAdviseTagStat: {
                	bigV: [],
                hero: [],
                team: [],
                gonglue: []
            },
            loadingConf: {
                	tagAdvise: true,
                contentChart: true,
                keywordChart: true
            }
        }
    },
    components: {},
    mounted(){
        this.getContentTrendsData().then(()=>{
            this.drawContentTrendChart();
        });
        this.getkeywordTredsData().then(()=>{
            this.drawKeywordChart();
        });
        this.getAdviseTagList();
    },
    methods: {
        onDateChange(chartName){
            if(chartName == 'contentTrendChart'){
	                this.loadingConf.contentChart = true;
	                this.getContentTrendsData().then(()=>{
		                this.drawContentTrendChart();
	                });
            }else if(chartName == 'hotTagChart'){
	                this.loadingConf.keywordChart = true;
	                this.getkeywordTredsData().then(()=>{
		                this.drawKeywordChart();
	                });
            }
        },
        goToTagAnalyze(tag) {
            this.$router.history.push({
                name: 'v4-laboratory-radar-detail', params: tag
            })
        },
        async getContentTrendsData() {
            this.loadingConf.contentChart = true;
            let param = {
                'endTime': this.contentTrendConf.param.endTime
            };
            let response = await ContentTrendsData(param);
            if(response.status == 200){
                let data = response.data;
                if (data.code == 0) {
                    this.formatContentTrendsStat(data.data);
                }
            }else {
                this.loadingConf.tagAdvise = false;
                return false;
            }
        },
        async getkeywordTredsData() {
            let param = {
                'endTime': this.keywordChartConf.param.endTime 
            };
            let response = await KeywordTrendsData(param);
            if(response.status == 200){
                let data = response.data;
                if (data.code == 0) {
                    this.formatKeywordStat(data.data);
                }
            }
        },
        async getAdviseTagList() {
            let param = {
                'endTime': '2018-07-16' 
            };
            let response = await TrendAdviseTagList(param);
            this.loadingConf.tagAdvise = false;
            if(response.status == 200){
                let data = response.data;
                if (data.code == 0) {
                    this.trendAdviseTagStat = data.data;
                }
            }
        },
        drawKeywordChart() {
	            this.loadingConf.keywordChart = false;
            if(this.keywordChart){
                this.keywordChart.destroy();
            }
	            let data = this.keywordStat;
	            let fields = this.keywordChartConf.fields;

	           // 创建数据集 DataSet 实例，管理 state 状态量
	            let ds = new DataSet();

	            //  在 DataSet 实例下创建名为 populationByAge 的数据视图
	            this.keywordChartDV = ds.createView().source(data);
	            this.keywordChartDV.transform({
		            type: 'fold',
		            fields: fields, // 展开字段集
		            key: 'dKey', // key字段
		            value: 'dValue'// value字段
	            });

	            let colorMap = {
		            '英雄': '#9ba6e2',
		            '攻略': '#40aaff',
		            '赛事': '#ff7347',
		            '战队': '#fbba6d',
		            '大V': '#fbbacc'
	            };
	            this.keywordChart = new G2.Chart({
		            container: 'keywordChart',
		            forceFit: true,
		            height: 402
	            });
	            this.keywordChart.source(this.keywordChartDV);
	            this.keywordChart.axis('dValue', {
		            label: {
			            formatter: function formatter(val) {
				            return `${val / 1000  }K`;
			            }
		            }
	            });
	            this.keywordChart.interval().position('dKey*dValue').color('name', (name) => {
		            return colorMap[name]
	            }).adjust([{
		            type: 'dodge',
		            marginRatio: 1 / 32
	            }]);
            this.keywordChart.render();
            G2.track(false)
        },
        formatKeywordStat(data){
            let cates = data.data;
            let arr = [];
            let fields = new Set();
            data.date.map((d)=>{
                fields.add(`'${d}'`);
            });
            for (let key of Object.keys(cates)) {
                let tBox = {};
                let cate = cates[key];
                let hotrank = cate.hotrank;
                // 当前日期数据对象
                let kObj = {
                    	name: cate.cateName
                }
                for (let k of Object.keys(hotrank)) {
                    kObj[`'${k}'`] = hotrank[k];
                }
                Object.assign(tBox, kObj, {
                    name: cate.cateName
                });
                arr.push(tBox);
            }
            this.keywordStat = arr;
            this.keywordChartConf.fields = Array.from(fields);
        },
        formatContentTrendsStat(data){
            let cates = data.data;
            let dKeySet = new Set();
            let tBox = {};
            data.date.map((d)=>{
                tBox[d] = {
                    "Stack": `'${d}'`
                };
            });
            for (let key of Object.keys(cates)) {
                let cate = cates[key];
                let cateNum = cate.num;
                // 当前日期数据对象
                data.date.map((d)=>{    // 该分类下
                    let kObj = {};
                    let cObj = {};
                    let k = `${cate.stack}-${cate.cateName}`;
                    dKeySet.add(k);
                    kObj[k] = cateNum[d];
                    cObj[k] = this.colors[dKeySet.size-1];
                    Object.assign(tBox[d], kObj);
                    Object.assign(this.contentTrendConf.colorMap, cObj);
                });
            }
            this.contentTrendConf.dKey = Array.from(dKeySet);
            this.contentTrendsStat = Object.values(tBox);
        },
        drawContentTrendChart() {   // g2 grapic demo
            this.loadingConf.contentChart = false;
            if (typeof G2 !== 'undefined') G2.track(false);
            let _DataSet = DataSet, DataView = _DataSet.DataView;
            let _G = G2, Chart = _G.Chart;
            if(this.contentTrendChart){
                this.contentTrendChart.destroy();
            }
            // 1.G2 对数据源格式的要求，仅仅是 JSON 数组，数组的每个元素是一个标准 JSON 对象。
            // 2.一个日期对应一个Stack,一个Stack内的数据分组由type决定，
            let data = this.contentTrendsStat;
            let dKeys = this.contentTrendConf.dKey;
            let dv = new DataView();

            dv.source(data).transform({
                type: 'fold',
                fields: dKeys,
                key: 'dKey',
                value: 'dValue',
                retains: ['Stack']
            }).transform({
                type: 'map',
                callback: function callback(obj) {
                    let key = obj.dKey;
                    let type = void 0;
                    if (key.indexOf('发布量')) {
                        type = 'a';
                    }else {
                        type = 'd';
                    }
                    obj.type = type;
                    return obj;
                }
            });


            let colorMap = this.contentTrendConf.colorMap;
            // Step 1: 创建 Chart 对象
            this.contentTrendChart = new Chart({
                container: 'contentTrendChart', // 指定图表容器 ID
                forceFit: true,
                height: 402, // 指定图表宽度 height:600
                padding: [20, 160, 80, 60],
                width: 402
            });
            // Step 2: 载入数据源
            this.contentTrendChart.source(dv, {
                dKey: {
                    // tickInterval: 1000000
                }
            });
            this.contentTrendChart.axis('dValue', {
                label: {
                    formatter: function formatter(val) {
                        return `${val / 1000  }K`;
                    }
                }
            });
            // 图例配置
            this.contentTrendChart.legend({
                position: 'right-top',
                itemGap: 20 // 图例项之间的间距
            });

            // Step 3：创建图形语法，绘制柱状图，由 Stack 和 population 两个属性决定图形位置，Stack 映射至 x 轴，population 映射至 y 轴
            this.contentTrendChart.interval().position('Stack*dValue').color('dKey', (dKey) => {
                // 设置颜色
                return colorMap[dKey];
            }).tooltip('dKey*dValue', (dKey, population) => {
                //
                return {
                    name: dKey,
                    value: population
                };
            }).adjust([{
                type: 'dodge',
                dodgeBy: 'type', // 按照 type 字段进行分组
                marginRatio: 0.2 // 分组中各个柱子之间不留空隙
            }, {
                type: 'Stack'
            }]);
            // Step 4: 渲染图表
            this.contentTrendChart.render();
            G2.track(false)
        }

    },
    computed: {}
}




</script>
